import React, { FC, memo } from "react";
import { Icon, IconToggleButton } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { TableViewIcon, ViewTypeContainer } from "./styled";
import { useViewType } from "../../hooks/useViewType";
import { ResourceViewType } from "./types";

const ViewTypeComponent: FC = () => {
  const { t } = useTranslation("catalog");
  const [viewType, updateViewType] = useViewType();

  return (
    <ViewTypeContainer>
      <IconToggleButton
        onClick={() => updateViewType(ResourceViewType.Grid)}
        isSelected={viewType === ResourceViewType.Grid}
        title={t("tileView")}
      >
        <Icon kind={"basemap"} />
      </IconToggleButton>
      <IconToggleButton
        onClick={() => updateViewType(ResourceViewType.Table)}
        isSelected={viewType === ResourceViewType.Table}
        title={t("tableView")}
      >
        <TableViewIcon kind={"textJustify"} />
      </IconToggleButton>
    </ViewTypeContainer>
  );
};

export const ViewType: FC = memo(ViewTypeComponent);
